import { Link } from 'react-router-dom';
import { toFullUrl } from '../../config/api';
import { LogoEmbers } from './LogoEmbers';

export function HeroSection({ siteSettings }) {
  return (
    <section className="relative border-b border-[#262626]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
        <div className="flex flex-col items-center text-center">
          {siteSettings?.hero_image && (
            <div className="relative flex items-center justify-center mb-8" data-testid="hero-logo-badge" style={{ minHeight: '300px' }}>
              <LogoEmbers />
              <div className="relative z-10 hero-logo-float">
                <div className="hero-logo-twirl">
                  <img
                    src={toFullUrl(siteSettings.hero_image)}
                    alt="Logo"
                    className="hero-logo-img w-48 h-48 sm:w-64 sm:h-64 lg:w-80 lg:h-80 object-contain drop-shadow-2xl"
                  />
                </div>
              </div>
            </div>
          )}
          <p className="overline mb-4" style={{ color: 'var(--primary, #FF3B30)' }}>{siteSettings?.hero_subheading || 'YOUR MUSIC DESTINATION'}</p>
          <h1 className="font-cabinet text-5xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tighter leading-none mb-6" style={{ color: 'var(--header-text, #FFFFFF)' }}>
            {(() => {
              const heading = siteSettings?.hero_heading || "STREAM.\nDOWNLOAD.\nSUPPORT.";
              const lines = heading.split('\n');
              return lines.map((line, i) => (
                <span key={i}>
                  {i === 1 ? <span style={{ color: 'var(--primary, #FF3B30)' }}>{line}</span> : line}
                  {i < lines.length - 1 && <br />}
                </span>
              ));
            })()}
          </h1>
          <p className="text-[#A3A3A3] text-lg max-w-md mb-8">
            {siteSettings?.hero_description || 'All my music in one place. Stream on your favorite platform or download directly.'}
          </p>
          <div className="flex flex-wrap gap-4 items-center">
            <Link to="/tracks" className="btn-primary" data-testid="browse-tracks-btn">
              BROWSE TRACKS
            </Link>
            <Link to="/apply"
              className="group inline-flex items-center gap-3 px-4 py-2.5 border-2 border-[#DAA520]/60 hover:border-[#DAA520] bg-[#DAA520]/5 hover:bg-[#DAA520]/15 transition-colors"
              data-testid="hero-apply-cta">
              <span className="w-9 h-9 bg-[#DAA520] text-black flex items-center justify-center font-cabinet font-black text-lg group-hover:rotate-[-6deg] transition-transform">
                FA
              </span>
              <span className="text-left">
                <span className="block text-[10px] text-[#DAA520] tracking-[0.25em] font-bold uppercase leading-none">Featured Artist</span>
                <span className="block text-sm font-black uppercase tracking-wider leading-tight mt-0.5">APPLY NOW →</span>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
